import React, { Component } from "react";
import styled from "styled-components";

import Hero from "./Hero.js";
import About from "./About.js";
import Locations from "./Locations.js";
import "./App.css";
import IconDeck from "./IconDeck.js";

const SubHeading = styled.h1`
  color: #393f4d;
  font-family: "Helvetica", sans-serif;
  font-size: 48px;
  font-weight: 700;
  line-height: 48px;
  margin: 50px 0;
  padding: 0 30px;
  text-align: center;
  text-transform: uppercase;
`;
class App extends Component {
  render() {
    return (
      <div>
        <Hero />
        <SubHeading>What We Do</SubHeading>
        <IconDeck />
        <SubHeading>About Red River Glazing</SubHeading>
        <About />
        <SubHeading>Our Locations</SubHeading>
        <Locations />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Homepage.js